import { ConstantsWebexApi } from "../constants/ConstantsWebexApi";
import { LocalCacheHelper } from "./LocalCacheHelper";

export class WebexApiHelper {

    public static GetWebexRequestHeadersWithoutAuth(): Headers {
        const webexHeaders: Headers = new Headers();
        webexHeaders.append("Content-Type", "application/json; charset=utf-8");
        // webexHeaders.append("X-BROADSOFT-PROTOCOL-VERSION", "1.0");
        return webexHeaders;
    }

    public static GetWebexRequestHeadersWithAuth(bearerToken: string, cpbx1GroupId: string): Headers {
        const webexHeaders: Headers = this.GetWebexRequestHeadersWithoutAuth();
        webexHeaders.append("Authorization", "Bearer " + bearerToken);
        webexHeaders.append("X-TeamsApp-Cpbx1GroupId", cpbx1GroupId);
        return webexHeaders;
    }

    public static GetWebexUrlForPresenceGet(): string {
        // e.g.: https://webexapis.com/v1/people/?email=thomas01.test02@deutschland-lan.de
        return (
            LocalCacheHelper.GetLocalStorageItemCbpxProxyUrl() +
            ConstantsWebexApi.ProxyUrl +
            ConstantsWebexApi.PartApiVersionPath +
            ConstantsWebexApi.Part1People +
            "/?email="
        );
    }
}
